import { combineReducers } from 'redux';
import _ from 'lodash';

import {
  createApiReducer,
  chainReducers,
  INITIAL_API_STATE_ITEMS,
} from 'src/api';

import {
  FETCH_VENDORS_START,
  FETCH_VENDORS_SUCCESS,
  FETCH_VENDORS_FAILURE,
  ADD_VENDOR_START,
  ADD_VENDOR_SUCCESS,
  ADD_VENDOR_FAILURE,
  UPDATE_VENDOR_START,
  UPDATE_VENDOR_SUCCESS,
  UPDATE_VENDOR_FAILURE,
  DELETE_VENDOR_START,
  DELETE_VENDOR_SUCCESS,
  DELETE_VENDOR_FAILURE,
} from './actions';

export const transformVendor = response => {
  return {
    id: response.id,
    businessEntityType: _.get(response, 'vendor_business_entity_type.id'),
    businessEntityTypeName: _.get(
      response,
      'vendor_business_entity_type.business_entity_type_type'
    ),
    businessName: response.vendor_business_name,
    ssn: response.vendor_ssn_new,
    naicsCode: response.vendor_naics_code,
    primaryAddress: response.vendor_primary_address,
    primaryAddress2: response.vendor_primary_address_2,
    primaryCity: response.vendor_primary_city,
    primaryState: response.vendor_primary_state,
    primaryZipcode: response.vendor_primary_zipcode,
    businessEmail: response.vendor_business_email,
    primaryPhone: response.vendor_primary_phone,
    otherPhone: response.vendor_other_phone,
    website: response.vendor_website,
    registeredState: response.vendor_registered_state,
    goodsAndServicesProvided: response.vendor_goods_and_services_provided,
    isApproved: response.vendor_is_approved,
    isDenied: response.vendor_is_denied,
    isArchived: response.vendor_is_archived,
  };
};

const transformVendors = response => {
  return {
    items: response.results.map(transformVendor),
    _paging: {
      page: response.paging.page,
      pageSize: response.paging.page_size,
      totalResults: response.paging.total_results,
      totalPages: Math.ceil(
        response.paging.total_results / response.paging.page_size
      ),
    },
  };
};

const fetchVendorsReducer = createApiReducer(
  [FETCH_VENDORS_START, FETCH_VENDORS_SUCCESS, FETCH_VENDORS_FAILURE],
  transformVendors,
  error => _.get(error, 'payload.response', 'unknown error')
);

const addVendorReducer = createApiReducer(
  [ADD_VENDOR_START, ADD_VENDOR_SUCCESS, ADD_VENDOR_FAILURE],
  (payload, state) => {
    const newVendor = transformVendor(payload);

    return {
      ...state.data,
      items: [...state.data.items, newVendor],
    };
  },
  error => transformVendor(_.get(error, 'payload.response', {}))
);

const updateItem = (list, key, value, newItem) => {
  return list.map(item => {
    if (item[key] === value) {
      return newItem;
    }
    return item;
  });
};

const updateVendorReducer = createApiReducer(
  [UPDATE_VENDOR_START, UPDATE_VENDOR_SUCCESS, UPDATE_VENDOR_FAILURE],
  (payload, state) => {
    const newVendor = transformVendor(payload);

    return {
      ...state.data,
      items: updateItem(state.data.items, 'id', newVendor.id, newVendor),
    };
  },
  error => transformVendor(_.get(error, 'payload.response', {}))
);

const deleteVendorReducer = createApiReducer(
  [DELETE_VENDOR_START, DELETE_VENDOR_SUCCESS, DELETE_VENDOR_FAILURE],
  (payload, state) => {
    return {
      ...state.data,
      items: state.data.items.filter(vendor => vendor.id !== payload.id),
    };
  },
  error => transformVendor(_.get(error, 'payload.response', {}))
);

export const vendor = chainReducers(
  INITIAL_API_STATE_ITEMS,
  fetchVendorsReducer,
  addVendorReducer,
  updateVendorReducer,
  deleteVendorReducer
);

export const reducer = combineReducers({
  vendor,
});
